import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=70c3373f&scoped=true&"
var script = {}
import style0 from "./NavBar.vue?vue&type=style&index=0&id=70c3373f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3373f",
  null
  
)

export default component.exports